export default __webpack_public_path__ + "static/media/raining-geodrops.fb9e3234.svg";